import type { TimeEntryHydraItem, TimeEntryWrite } from "@verbleif/lib/src/composables/Api/Type/TimeEntry/timeEntry.interface";

import type { TimeEntryObjectSchema } from "./TimeentrySchema";
import dayjs from "dayjs";

function formatEndedAt(value: Date | null | undefined): string | null | undefined {
  if (value === undefined) {
    return undefined;
  }
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return null;
  }

  const formatted = dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ");
  if (formatted === "Invalid Date") {
    return null;
  }

  return formatted;
}

export function useTimeEntryTransformer() {
  function inputTransformer(timeEntry: TimeEntryHydraItem): TimeEntryObjectSchema {
    return {
      task: timeEntry.task ?? "",
      startedAt: typeof timeEntry.startedAt === "string" ? dayjs(timeEntry.startedAt).toDate() : null,
      endedAt: typeof timeEntry.endedAt === "string" ? dayjs(timeEntry.endedAt).toDate() : null,
      billable: timeEntry.billable,
      manual: !!timeEntry.manual,
      notes: timeEntry.notes,
    };
  };

  function outputTransformer(TimeEntry: TimeEntryObjectSchema): TimeEntryWrite {
    return {
      task: TimeEntry.task,
      startedAt: dayjs(TimeEntry.startedAt).format("YYYY-MM-DDTHH:mm:ssZ"),
      endedAt: formatEndedAt(TimeEntry.endedAt) ?? null,
      billable: TimeEntry.billable,
      manual: TimeEntry.manual,
      notes: TimeEntry.notes,
    };
  }

  function outputPartialTransformer(input: Partial<TimeEntryObjectSchema>): Partial<TimeEntryWrite> {
    return {
      task: input.task !== undefined ? input.task : undefined,
      startedAt: input.startedAt !== undefined ? dayjs(input.startedAt).format("YYYY-MM-DDTHH:mm:ssZ") : undefined,
      endedAt: formatEndedAt(input.endedAt),
      billable: input.billable !== undefined ? input.billable : undefined,
      manual: input.manual !== undefined ? input.manual : undefined,
      notes: input.notes !== undefined ? input.notes : undefined,
    };
  }

  return {
    inputTransformer,
    outputTransformer,
    outputPartialTransformer,
  };
}
